<!-- Card -->
<section class="card">
  <!-- Header -->
  <div class="card-header">
    <h3 class="card-title">
      {{ 'general.general' | translate }}
    </h3>
  </div>
  <!-- End Header -->

  <!-- Body -->
  <div class="card-body">
    <operation-internal-event-form
      (onSubmit)="onSubmit($event)"
      [operationInternalEvent]="operationInternalEvent$ | async"
    >
    </operation-internal-event-form>
  </div>
  <!-- End Body -->
</section>
<!-- End Card -->
